export default "__VITE_ASSET__BdyEgx3y__"